import { AtTabs, Tab } from '../../atoms'
import { MlGeneralWorkspaceCard, MlGeneralWorkspaceCardProps } from '../../molecules'
import { MlBuildingCardProps } from '../../molecules/ml-building-card'
import { MlSpaceCardProps } from '../../molecules/ml-space-card'
import { CarouselType, OrCardCarousel } from '../or-card-carousel'
import { Section } from '../or-flexible-block/index.components'

export type OrCardsBlockProps = { title: string } & (
  | { type: 'space'; cards: (Omit<Tab, 'content'> & { content: MlSpaceCardProps[] })[] }
  | { type: 'building'; cards: (Omit<Tab, 'content'> & { content: MlBuildingCardProps[] })[] }
  | { type: 'workspace'; cards: MlGeneralWorkspaceCardProps[] }
)

export const OrCardsBlock = ({ title, type, cards }: OrCardsBlockProps) => {
  switch (type) {
    case 'workspace': {
      return (
        <Section title={title}>
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-7.5">
            {cards.map((card, i) => (
              <MlGeneralWorkspaceCard key={i} {...card} />
            ))}
          </div>
        </Section>
      )
    }

    case 'space': {
      return (
        <Section title={title}>
          <AtTabs
            hasButtons
            tabs={cards.map(({ content, ...tab }) => ({
              ...tab,
              content: <OrCardCarousel cards={content} embedded />,
            }))}
          />
        </Section>
      )
    }

    case 'building': {
      return (
        <Section title={title}>
          <AtTabs
            hasButtons
            tabs={cards.map(({ content, ...tab }) => ({
              ...tab,
              content: <OrCardCarousel type={CarouselType.Building} cards={content} embedded />,
            }))}
          />
        </Section>
      )
    }
  }
}
